import { Product } from 'src/app/core/services/billing.service';

export const environment = {
  production: true,
  appVersion: require('../../package.json').version,
  heapAppId: '1250160802',
  intercomAppId: 'mgjydob6',
  moneyballSubscriptionPriceId: 'price_1QDuYCKjCB7MuRGZ0cyLE7RR',
  moneyballSubscriptionProductId: 'prod_R66lnCqs9qjMkH',
  peopleSubscriptionProductId: 'prod_SBW2XdgxrOv7vs',
  // Workforce.ai (chat) subscription.
  chatSubscriptionProductId: 'prod_UfMklb6JcZIBBE',
  chatProSubscriptionPriceId: 'price_1Tg218KjCB7MuRGZYYrMmceb',
  chatTeamSubscriptionPriceId: 'price_1Tg218KjCB7MuRGZCvvkWiQn',
  ledgerApiBasePath: 'https://gotlivedata.io/api/ledger/v1',
  ledgerApiBasePathV2: 'https://gotlivedata.io/api/ledger/v2',
  identityApiBasePath: 'https://gotlivedata.io/api/identity/v1',
  cleanApiBasePath: 'https://gotlivedata.io/api/clean/v2',
  onboardingApiBasePath: 'https://gotlivedata.io/api/onboarding/v1',
  billingApiBasePath: 'https://gotlivedata.io/api/billing/v1',
  dwReaderApiBasePath: 'https://gotlivedata.io/api/dw/v1',
  growApiBasePath: 'https://gotlivedata.io/api/grow',
  devDeploysApiBasePath: 'https://dwh-pipeline.gotlivedata.io/api/dynamo/v1',
  moneyballApiBasePath: 'https://gotlivedata.io/api/moneyball/v1',
  peopleApiBasePath: 'https://gotlivedata.io/api/people/v1',
  dataDeliveryApiBasePath: 'https://gotlivedata.io/api/deliveries/v1',
  resolverApiBasePath: 'https://gotlivedata.io/api/resolver/v1',
  chatApiBasePath: 'https://gotlivedata.io/api/chat/v1',
  GCS_DESTINATION_TYPE_ID: 8,
  SNOWFLAKE_DESTINATION_TYPE_ID: 5,
  stateStorageApiBasePath: 'https://gotlivedata.io/api/state_storage/v1',
  recaptchaV3SiteKey: '6LfmIkweAAAAAM689lhlWcgbrKSol1Mh7X7Ngw81',
  onboardingNotificationURL: 'https://6d37285ddbed7749cd09a734325ce9cb.m.pipedream.net',
  googleAuthClientId: '615192757992-spf0aq02d2oak0iprkk7h2oae8gskf15.apps.googleusercontent.com',
  googleSheetsClientId: '548405968375-2thi10dnf9t72rqdmscri5g1i7c9qc0c.apps.googleusercontent.com', // TODO: Replace with your production OAuth Client ID
  microsoftAuthClientId: '93de5405-e82b-43fb-9dbc-7a9037f1add5',
  flatfileEnvironmentId: 'us_env_Fest5Hst',
  flatfilePublishableKey: 'pk_7374bf5668b34e849d9ee35a702465e5',
  providerIntakeApiBasePath: 'https://gotlivedata.io/api/providerintake',
  chatProtoApiBasePath: 'https://wkhlw1b9b1.execute-api.us-east-1.amazonaws.com/',
  providersApiBasePath: 'https://gotlivedata.io/api/providers/v1',
  tasksApiBasePath: 'https://gotlivedata.io/api/tasks/v1',
};

export const customerProducts: Product[] = [
  {
    id: 'prod_SBW2XdgxrOv7vs',
    prices: [
      {
        priceId: 'price_1RH908KjCB7MuRGZFwV0aNjj',
        price: 99,
        qty: 2000,
      },
      {
        priceId: 'price_1RMEowKjCB7MuRGZPq5NmUc0',
        price: 199,
        qty: 5000,
      },
      {
        priceId: 'price_1RPV8KKjCB7MuRGZM4imQXze',
        price: 349,
        qty: 10000,
      },
      {
        priceId: 'price_1RPV8SKjCB7MuRGZJ3rMQUPe',
        price: 599,
        qty: 20000,
      },
      {
        priceId: 'price_1RPV8lKjCB7MuRGZzNCkSPQR',
        price: 1299,
        qty: 50000,
      },
      {
        priceId: 'price_1SooB0KjCB7MuRGZ5rqRmnQW',
        price: 1999,
        qty: 100000,
      },
      {
        priceId: 'price_1SooEYKjCB7MuRGZMC11xf29',
        price: 2999,
        qty: 200000,
      },
    ],
  },
];
